/**
 * The Esc rule of `LayerProvider` as a pure decision (UI r1 deliverable 6,
 * as ruled in DECISIONS entry 53 item 24).
 *
 * - A composing Esc, or one with no layer open, is left alone.
 * - When the innermost layer is a region layer (a peek) and the event's
 *   target is editable text, the target gets the Esc first; the provider
 *   closes the layer afterwards only if nothing consumed it
 *   (`preventDefault`) and the layer is still the innermost.
 * - Otherwise the provider closes the innermost layer at once, in the
 *   capture phase, before anything below sees the key.
 */
export function decideEscape(input) {
    if (input.key !== 'Escape')
        return 'ignore';
    if (input.isComposing || input.keyCode === 229)
        return 'ignore';
    if (!input.hasLayer)
        return 'ignore';
    if (input.innermostHasRegion && input.targetEditable)
        return 'defer';
    return 'close';
}
/** After a deferral: close the layer only if the Esc went unused and the layer is still innermost. */
export function decideDeferred(input) {
    return !input.defaultPrevented && input.stillInnermost;
}
/** Editable text: a contenteditable element, or an `input`, `textarea` or `select`. */
export function isEditableTarget(target) {
    if (!target || typeof target !== 'object')
        return false;
    const el = target;
    if (el.isContentEditable === true)
        return true;
    const tag = typeof el.tagName === 'string' ? el.tagName.toUpperCase() : '';
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}
//# sourceMappingURL=layers.js.map